import { useEffect } from 'react';
import './App.css';
import RoutesCollection from './routes';
import { AuthProvider } from './context/authContext';
import { DashboardProvider } from './context/dashboardContext';
import { SidebarProvider } from './context/CollapsedContext';
import { Toaster } from 'react-hot-toast';
import { SearchProvider } from '../src/context/SearchContext';

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('appFontSize');
    if (saved) {
      document.documentElement.style.setProperty('--app-font-size', saved + 'px');
    }
  }, []);

  return (
    <SidebarProvider>
      <AuthProvider>
        <DashboardProvider>
          <SearchProvider>
            <>
              <Toaster position="top-center" reverseOrder={false}  toastOptions={{duration: 4000}} />
              <RoutesCollection />
            </>
          </SearchProvider>
        </DashboardProvider>
      </AuthProvider>
    </SidebarProvider>
  );
}

export default App;